export default "__VITE_ASSET__Cc6GbIf7__"